export default __webpack_public_path__ + "static/BanImg2-0ae1c34f2dacf9243ac9fdad608f616f.webp";